import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局挂载
const zh = require("./zh_CN.js")
console.log("aaa",zh)
export const i18n = new VueI18n({
    locale: 'zh',//  localStorage.getItem("locale") || "zh", // 从localStorage中获取 默认英文
    messages: {
        zh: require("./zh_CN.js"), // 中文语言包
        en: require("./en_US.js") // 英文语言包
    }
});

export default i18n;